import styled from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';

export const Container = styled.div`
    padding: ${(props) => (props.isArray ? '32px 32px 56px 32px' : '32px')};
    box-shadow: ${promoColors.shadowLoose};
    border-radius: 24px;
    text-align: center;
    box-sizing: border-box;
    min-height: 100%;
    width: 100%;
    background: ${(props) => promoColors[props.bgColor]};

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.isArray ? '48px 48px 80px 48px' : '48px')};
        border-radius: 36px;
    }

    ${promoMedia.desktop1440} {
        padding: ${(props) => (props.isArray ? '64px 64px 104px 64px' : '64px')};
        border-radius: 40px;
    }
`;

export const IconContainer = styled.div`
    margin: 0 auto 32px;
    width: 40px;
    height: 40px;

    ${promoMedia.tablet744} {
        width: ${(props) => (props.coloredTile ? '40px' : '48px')};
        height: ${(props) => (props.coloredTile ? '40px' : '48px')};
    }

    ${promoMedia.desktop1440} {
        width: ${(props) => (props.coloredTile ? '40px' : '80px')};
        height: ${(props) => (props.coloredTile ? '40px' : '80px')};
    }

    img {
        height: auto;
        width: 100%;
    }
`;

export const TitleContainer = styled.div`
    margin-bottom: 32px;
`;

export const BtnContainer = styled.div`
    margin-top: 16px;
`;

export const ImgContainer = styled.div`
    width: 40px;
    border-radius: 50%;
    border: 1px solid ${promoColors.gray5};
    overflow: hidden;
    margin: 0 auto;

    ${promoMedia.tablet744} {
        width: 48px;
    }

    ${promoMedia.desktop1440} {
        width: 80px;
    }
`;

export const Description = styled.div`
    margin-top: 8px;

    ${promoMedia.tablet744} {
        margin-top: 16px;
    }
`;
